// @flow
import _ from 'lodash';

import { asyncCall } from './async';
import { applyBindingsToNode, type applyBindingNodeParams } from './ko-dependencies';
import {findElementById} from './dom-workers';

export type LodashFunctor = (Object) => string

const render = (selector: string | Node, params: applyBindingNodeParams): Promise<void> => {
	return new Promise(resolver => {
		asyncCall(() => {
			const element = _.isString(selector) ? findElementById(selector) : selector;

			applyBindingsToNode(element, params);
			resolver();
		});
	});

};

export {
	render,
};
